
<template>
  <el-dialog
      title="发送公告"
      :visible="visible"
      width="530px"
      @close="setVisible(false)"
      :close-on-click-modal="false"
  >
    <el-form
      ref="msgForm"
      :model="msgData"
      :rules="msgRules"
      label-width="80px"
      label-position="left"
    >
      <el-form-item label="官方ID" prop="uid">
        <el-input v-model.number="msgData.uid"></el-input>
      </el-form-item>
      <el-form-item label="内容" prop="content">
        <el-input
          type="textarea"
          size="small"
          :autosize="{ minRows: 3, maxRows: 6 }"
          v-model="msgData.content"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="setVisible(false)" size="medium"
        >取 消</el-button
      >
      <el-button type="primary" @click="confirmSend" size="medium"
        >确 认</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'EditNotice',
  emits: ['submit'],
  data() {
    return {
      visible: false,
      msgData: {
        uid: "",
        // toUid: "",
        content: "",
      },
      msgRules: {
        uid: [{ required: false, message: "请输入官方ID", trigger: "blur" }],
        // toUid: [{ required: true, message: "请输入用户ID", trigger: "blur" }],
        content: [
          { required: true, message: "请输入信息内容", trigger: "blur" },
        ],
      },
    };
  },

  mounted() {
    
  },

  methods: {
    setVisible(val) {
      this.visible = val
    },
    confirmSend() {
      this.$refs.msgForm.validate((r) => {
        if (r) {
          this.$emit('submit', this.msgData)
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>

</style>